import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { styleOverrides } from './Link-mui-overrides';
import './Link.scss';

export const Link = (props) => {
  const {
    href,
    variant = 'primary',
    startIcon,
    endIcon,
    chevron,
    buttonLink,
    children,
    darkButton,
    target = '_self',
    onClick,
    extendClass = '',
    noUnderline,
    extendTestId = '',
  } = props;
  const secondaryClass = variant === 'secondary' ? 'link-secondary' : 'link-primary';
  const withChevronClass = chevron ? 'chevron' : '';
  const btnLinkClass = buttonLink ? 'btn btn-link' : '';
  const noUnderlineClass = noUnderline ? 'no-underline' : '';
  const darkButtonClass = buttonLink && darkButton ? 'btn-dark' : 'btn-light';
  const testId = extendTestId ? `link-${extendTestId}` : 'link';

  const classes = [
    'link',
    secondaryClass,
    withChevronClass,
    btnLinkClass,
    darkButtonClass,
    extendClass,
    noUnderlineClass,
  ].join(' ');

  const componentVariant = buttonLink && { variant: 'outlined' };
  const componentArgs =
    href === '#' ? { component: 'button', onClick } : { component: 'a', href, target };

  return (
    <ThemeProvider theme={styleOverrides}>
      <Button
        className={classes}
        startIcon={startIcon}
        endIcon={endIcon}
        {...componentVariant}
        {...componentArgs}
        disableRipple
        disableTouchRipple
        focusRipple={false}
        data-testid={testId}
        onClick={onClick}
      >
        {children}
      </Button>
    </ThemeProvider>
  );
};

Link.propTypes = {
  href: PropTypes.string.isRequired,
  variant: PropTypes.string,
  startIcon: PropTypes.element,
  endIcon: PropTypes.element,
  chevron: PropTypes.bool,
  buttonLink: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
  darkButton: PropTypes.bool,
  target: PropTypes.string,
  onClick: PropTypes.func,
  extendClass: PropTypes.string,
  noUnderline: PropTypes.bool,
  extendTestId: PropTypes.string,
};
